import { ASSINGCOURSE } from "../../actions/course/assign_course/assign_course_action";

export const initState = {
  is_done: false,
  loading: false,
  errors: [],
  userList: [],
  userCourseList: [],
  assignedCourseUserList: [],
  toDoCoursesList: [],
  completedCoursesList: []
};

const assignCourseReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case ASSINGCOURSE.ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    case ASSINGCOURSE.REQUEST:
      return {
        ...state,
        loading: true,
        is_done: false,
        errors: [],
        userList: [],
        userCourseList: [],
      };
    case ASSINGCOURSE.GET_USER_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        userList: payload,
      };
   
    case ASSINGCOURSE.ASSING_COURSE_TO_USER:
      return {
        ...state,
        loading: false,
        errors: [],
        is_done: true,
      };

    case ASSINGCOURSE.GET_ASSIGN_COURSE_USER_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        assignedCourseUserList: payload,
        is_done: false,
      };

    case ASSINGCOURSE.GET_ASSING_USER_COURSE:
      return {
        ...state,
        loading: false,
        errors:[],
        toDoCoursesList: payload.toDoCourses,
        completedCoursesList: payload.completedCourses,
        is_done: false,
      };

    default:
      return state;
  }
};

export default assignCourseReducer;
